let bound = false;
let request = 0;

const modal = (): HTMLElement | null => document.querySelector<HTMLElement>("[data-ch-modal]");
const backdrop = (): HTMLElement | null => document.querySelector<HTMLElement>("[data-ch-modal-backdrop]");

function close(): void {
  request += 1;
  modal()?.classList.remove("open");
  backdrop()?.classList.remove("open");
  modal()?.querySelectorAll<HTMLAudioElement>("audio").forEach((audio) => audio.pause());
}

async function open(url: string): Promise<void> {
  const box = modal();
  const content = box?.querySelector<HTMLElement>("[data-ch-modal-content]");
  if (!box || !content) return;

  document.querySelectorAll<HTMLElement>("[data-history-popover].open").forEach((p) => p.classList.remove("open"));
  content.innerHTML = '<div class="chm-loading">Loading…</div>';
  box.classList.add("open");
  backdrop()?.classList.add("open");

  const current = ++request;
  let html: string;
  try {
    const response = await fetch(url, { headers: { Accept: "text/html" }, credentials: "same-origin" });
    if (!response.ok) throw new Error(String(response.status));
    html = await response.text();
  } catch {
    html = '<div class="chm-loading">Could not load this contact.</div>';
  }
  if (current === request) content.innerHTML = html;
}

export function initContactHistoryModal(): void {
  if (bound) return;
  bound = true;

  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;
    const trigger = target.closest<HTMLElement>("[data-contact-history-open]");
    const url = trigger?.dataset.contactHistoryOpen;
    if (trigger && url) {
      e.preventDefault();
      e.stopPropagation();
      void open(url);
      return;
    }
    if (target.closest("[data-ch-modal-close]") || target.closest("[data-ch-modal-backdrop]")) {
      close();
      return;
    }
    const toggle = target.closest<HTMLElement>("[data-ch-toggle-sent]");
    if (toggle) {
      const sent = toggle.parentElement?.querySelector<HTMLElement>("[data-ch-sent]");
      if (sent) sent.hidden = !sent.hidden;
    }
  }, true);

  document.addEventListener("turbo:before-cache", close);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal()?.classList.contains("open")) close();
  });
}
